export const defaultReviewLexicon = {
  skus: {
    en: 'product SKUs',
    fr: 'SKUs produits',
    es: 'SKUs de los productos',
    it: 'SKUs prodotti',
    de: 'produkt SKUs',
    no: 'produkt SKUs',
  },
  tags: {
    en: 'tags',
    fr: 'tags',
    es: 'tags',
    it: 'tags',
    de: 'tags',
    no: 'etiketter',
  },
  additionalData: {
    en: 'additional data',
    fr: 'données additionnelles',
    es: 'datos complementarios',
    it: 'dati aggiuntivi',
    de: 'zusätzliche Daten',
    no: 'tilleggsdata',
  },
  fieldValues: {
    en: 'field values',
    fr: 'valeurs des champs',
    es: 'valores de los campos',
    it: 'valori dei campi',
    de: 'werte der Felder',
    no: 'feltverdier',
  },
  identity: {
    en: 'identity',
    fr: 'identité',
    es: 'identidad',
    it: 'identità',
    de: 'identität',
    no: 'identitet',
  },
  review: {
    en: 'review',
    fr: 'avis',
    es: 'reseña',
    it: 'recensione',
    de: 'bewertung',
    no: 'identitet',
  },
}
